<template>
  <div>
    <label for="street">Street &amp; number / PO box number</label>
    <input
      class="form-control"
      type="text"
      name="street"
      v-model="$store.state.subscriberData[name + 'Address']"
    />
    <label for="zip-code">ZIP code</label>
    <input
      class="form-control"
      type="text"
      name="zip-code"
      v-model="$store.state.subscriberData[name + 'Zip']"
    />
    <label for="country">Country</label>
    <CountryInput name="country" v-model="$store.state.subscriberData[name + 'Country']" />
  </div>
</template>

<script>
import CountryInput from "@/components/CountryInput.vue";

export default {
  name: "AddressForm",
  components: {
    CountryInput
  },
  props: {
    name: String
  }
};
</script>